/***
 * paralax Plugin
 * handels bringing an element into view from left or right
 * 
 ***/	
(function ( $ ) {
 
    $.fn.ptParalaxSideToCenter = function( options ) {

      // This is the easiest way to have default options.
      var settings = $.extend({
          // These are the defaults.
          side: 'left',
          start: 0,
          parent: '',
          outofview: '1000',
          percentOfScreen: 80
      }, options );
      
      var paralaxElement = $(this);
      var container;
      
      if(settings.parent == '') {
      	container = paralaxElement.closest('.container');
      } else {
      	container = settings.parent;
      }
		  
		  paralaxElement.css({'position':'relative'});
		  if(settings.side == 'left') {
		  	paralaxElement.css({'left':'-'+settings.outofview+'px'});
		  }
		  if(settings.side == 'right') {
		  	paralaxElement.css({'right':'-'+settings.outofview+'px'});
		  }
		  
		  var stopParalaxing = false;
      
      $(window).on('scroll', function() {
      	
      	var starting = $(window).scrollTop() + $(window).height() - container.offset().top;
      	var paralaxArea = $(window).height() * settings.percentOfScreen/100;
      	
      	if(starting < 0 ) {
    			percent = 0;
    		} else if (starting > paralaxArea)	{
    			percent = 1;
    			stopParalaxing = true;
    		} else {
    			
    			percent = starting/paralaxArea;
    		}
		
		    
		    if(!stopParalaxing) {
		        
		      if(settings.side == 'left') {
				  	paralaxElement.css({'left': 'calc('+(1-percent)+' * '+settings.start+')'});
				  }
				  if(settings.side == 'right') {
				  	paralaxElement.css({'right': 'calc('+(1-percent)+' * '+settings.start+')'});
				  }
		      paralaxElement.css({'opacity': percent});
		      
		    } else {
		        
		      if(settings.side == 'left') {
				  	paralaxElement.css({'left': 0});
				  }
				  if(settings.side == 'right') {
				  	paralaxElement.css({'right': 0});
				  }
		      paralaxElement.css({'opacity': 1});
		    }
		    
		  });
		  
		  $(window).trigger('scroll');
 
    };
 
}( jQuery ));